export default __webpack_public_path__ + "static/banner-time-to-call-a-builder-cf5e68c1161fe3129ae55b14391e32dd.jpg";